import { render } from "./budget-expenses.vue?vue&type=template&id=13be252d"
import script from "./budget-expenses.vue?vue&type=script&lang=js"
export * from "./budget-expenses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__